import {createApi} from "@reduxjs/toolkit/query/react";
import { LoginRequest } from "@/model/request/auth/LoginRequest";
import { baseQuery } from "../httpClient/baseQuery";
import { LoginResponse } from "@/model/response/authentication/LoginResponse";
import { SignUpRequest } from "@/model/request/auth/SignUpRequest";
import { SignUpResponse } from "@/model/response/SignUpResponse";


export const authApi = createApi({
    reducerPath: "authApi",
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        login: builder.mutation<LoginResponse, LoginRequest>({
            query: (body) => ({url: "/authentication/login", method: "POST", body}),
        }),
        signup: builder.mutation<SignUpResponse, SignUpRequest>({
            query: (body) => ({url: "/authentication/initiate-enrollment", method: "POST", body}),
        }),
    }),
});


export const {useLoginMutation, useSignupMutation} = authApi;